import { createFileRoute } from '@tanstack/react-router';
import messages from 'app/_authenticated/funds/messages';
import { SEO } from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { CryptoDepositCompleteComponent } from './components/CryptoDepositComplete';

export const Route = createFileRoute(
  '/_authenticated/funds/deposit/crypto/$productCode/complete',
)({
  component: CryptoDepositComplete,
});

function CryptoDepositComplete() {
  const { productCode } = Route.useParams();
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const fundsMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={fundsMessages.title}
        description={fundsMessages.description}
        keywords={fundsMessages.keywords}
        page={`/funds/deposit/crypto/${productCode}/complete`}
      />
      <div className="px-6 py-4">
        <CryptoDepositCompleteComponent />
      </div>
    </>
  );
}
